<template>
  <div class="container">
    <BaseFrame
      :infos="infos"
      :idText="idText"
      :cancelText="isMyOwnInfo?'':'取消'"
      saveText="保存"
      @clear="clear"
      @save="submit('headOfficeForm')"
      :saveLoading='saveLoading'
      @cancel="$router.push({ name: 'headOfficeAccountList' })"
    >
      <div slot="content">
        <lk-form :model="headOfficeForm" label-position="right" :label-width="130"
                 :rules="ruleValidate" ref="headOfficeForm">
          <div class="cardContainer">
            <lk-card title="基本信息">
              <lk-row>
                <lk-col span="7">
                  <lk-form-item label="账户名:" prop="sysUser.phone">
                    <lk-input :maxlength="11" placeholder="一旦提交不可修改，请您输入正确手机号" :disabled="!!$route.params.id"
                              v-model.trim="headOfficeForm.sysUser.phone"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="姓名:" prop="sysUser.name">
                    <lk-input :disabled='isMyOwnInfo' :maxlength="50" placeholder="请输入" v-model.trim="headOfficeForm.sysUser.name">
                    </lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="性别:" class="inline">
                    <lk-radio-group v-model.trim="headOfficeForm.sysUser.gender">
                      <lk-radio :label="1">男</lk-radio>
                      <lk-radio :label="2">女</lk-radio>
                    </lk-radio-group>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row>
                <lk-col span="7">
                  <lk-form-item label="邮箱:" prop="sysUser.email">
                    <lk-input :maxlength="100" placeholder="请输入" v-model.trim="headOfficeForm.sysUser.email"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="身份证:" prop="sysUser.idCard">
                    <lk-input :maxlength="100" placeholder="请输入" v-model.trim="headOfficeForm.sysUser.idCard">
                    </lk-input>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="角色信息">
              <lk-row>
                <lk-col span="23">
                  <lk-form-item label="总部角色:" prop="roleList" class="formatCheckbox">
                    <lk-checkbox-group v-model.trim="headOfficeForm.roleList">
                      <lk-checkbox v-for="(item, index) in headOfficeRoles" :disabled='item.disabled'
                                   :key="index" :label="item.id">
                        {{item.name}}
                      </lk-checkbox>
                    </lk-checkbox-group>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="负责门店">
              <lk-row >
                <lk-col span="23">
                  <lk-form-item label="门店名称:">
                    <lk-select multiple filterable style="min-width:150px"
                    :disabled='isMyOwnInfo'
                               v-model.trim="headOfficeForm.authStoreIdList" @on-change="isAllSelectStore">
                      <lk-option v-for="item in listStores" :key="item.id" :value="item.id" :disabled="allSelectStore">
                        {{item.name}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
    <DTPModal
      v-model="showClear"
      @confirm="confirmClear"
      content="重置将取消当前所做更改。"
      type="alert"
    ></DTPModal>
    <DTPModal
      v-model="showTest"
      @confirm="importInfo"
      @handleCancel="confirmClear"
      content="此账号已有门店权限，是否对此账号配置总部权限？"
      type="alert"
    ></DTPModal>
  </div>
</template>
<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import system from '@/services/system';
import utils from '@/libs/utils';
import DTPModal from '@/components/DTPModal.vue';

export default {
  name: 'HeadOfficeAccountEdit',
  components: {
    BaseFrame,
    DTPModal,
  },

  data() {
    const checkPhone = (rule, value, callback) => {
      // 手机号码远程验证重复
      // TODO 区分存在于总部还是门店账户

      if (this.$route.name === 'headOfficeAccountEdit' || this.saveLoading) {
        callback();
      } else {
        this.$store.commit('setDisableLoading', true);
        system.headOfficePhoneCheck({
          uid: this.$route.params.id,
          phone: value,
        })
          .then((res) => {
            if (res.data.status === 200) {
              this.tempInfo = res.data.data;
              if (this.tempInfo) {
                this.showTest = true;
              }
              callback();
            } else {
              callback(new Error(res.data.error));
            }
          })
          .catch((err) => {
            utils.handleError(err);
          });
      }
    };
    return {
      showTest: false,
      tempInfo: null,
      allSelectStore: false,
      checkRoleIds: [],
      showClear: false,
      idText: '',
      gender: ['', '男', '女'],
      headOfficeRoles: [], // 总部角色列表
      listStores: [], // 负责门店列表
      saveLoading: false,
      infos: null,
      headOfficeForm: {
        authStoreIdList: [], // 负责门店Id列表
        sysPositionList: [
          { sysStore: { id: 1 }, roleList: [] },
        ], // 总部角色Id列表
        sysUser: {
          phone: '', // 账号名
          name: '', // 姓名
          gender: '', // 性别
          email: '', // 邮箱
        }, // 用户信息
      },
      ruleValidate: {
        'sysUser.phone': [
          {
            required: true,
            message: '请输入账户名',
            trigger: 'blur',
          },
          {
            validator: utils.validate.cellPhoneValidator,
            message: '请输入正确手机号码',
            trigger: 'blur',
          },
          {
            validator: checkPhone,
            trigger: 'blur',
          },
        ],
        'sysUser.name': [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'change',
          },
        ],
        'sysUser.email': [
          {
            message: '请输入正确的邮箱',
            trigger: 'blur',
            type: 'email',
          },
        ],
        roleList: [
          {
            required: true,
            message: '请选择角色信息',
            trigger: 'blur',
            type: 'array',
          },
        ],
      },
    };
  },
  computed: {
    isMyOwnInfo() { // 判定是否为我的资料
      return this.$route.name === 'personalHQEdit';
    },
  },
  methods: {
    importInfo() {
      this.headOfficeForm.sysUser = this.tempInfo;
      this.showTest = false;
    },
    // TODO 操作日志
    submit(name) { // 验证函数
      this.headOfficeForm.sysPositionList[0].roleList = this.headOfficeForm.roleList;
      this.saveLoading = true;
      this.$refs[name].validate((valid) => {
        this.saveLoading = valid;
        if (valid) {
          if (['headOfficeAccountEdit', 'personalHQEdit'].includes(this.$route.name)) { // 编辑
            this.saveLoading = true;
            system.headOfficeUpdate(this.headOfficeForm)
              .then((res) => {
                if (res.data.status === 200) {
                  this.$Message.success('保存成功');
                  this.isMyOwnInfo || setTimeout(() => {
                    this.$router.push({ name: 'headOfficeAccountList' });
                    this.$store.commit('setStoreList', []);
                  }, 1000);
                  // setTimeout(() => {
                  // this.$router.push({ name: 'headOfficeAccountList' });
                  // }, 1000);
                } else {
                  this.$Message.error(res.data.error);
                }
                this.saveLoading = false;
              })
              .catch((err) => {
                this.saveLoading = false;
                utils.handleError(err);
              });
          } else {
            this.saveLoading = true;
            system.headOfficeSave(this.headOfficeForm)
              .then((res) => {
                if (res.data.status === 200) {
                  this.$Message.info({
                    duration: 10,
                    closable: true,
                    content: res.data.data.password ? `保存成功，新增用户工号为：${res.data.data.uid}    密码为：${res.data.data.password}` : '账户多类型设置成功，原密码保持不变',
                    // content: `保存成功，新增用户工号为:${res.data.data.uid}    密码为:${res.data.data.password}`,
                  });
                  // setTimeout(() => {
                  this.$router.push({ name: 'headOfficeAccountList', params: { create: true } });
                  // }, 1000);
                } else {
                  this.saveLoading = false;
                  this.$Message.error(res.data.error);
                }
              })
              .catch((err) => {
                utils.handleError(err);
              });
          }
        }
      });
    },

    getRoleInfos() {
      return new Promise((resolve) => {
        system.storeListEnable({ type: 1, page: 1, size: 10000 })
          .then((res) => {
            if (res.data.status === 200) {
              this.headOfficeRoles = res.data.data.list;
              this.headOfficeRoles.forEach((item) => {
                if (this.isMyOwnInfo) {
                  item.disabled = true;
                }
              });
              resolve();
            } else {
              this.$Message.error(res.data.error);
            }
          })
          .catch((err) => {
            utils.handleError(err);
          });
      });
    },
    getStoreInfos() {
      return new Promise((resolve) => {
        system.listStoresEnable()
          .then((res) => {
            if (res.data.status === 200) {
              this.listStores = res.data.data;
              resolve();
            } else {
              this.$Message.error(res.data.error);
            }
          })
          .catch((err) => {
            utils.handleError(err);
          });
      });
    },
    getInfos(id) {
      system.getUserInfo({ id })
        .then((res) => {
          if (res.data.status === 200) {
            // 填充面包屑导航下的信息
            const temp = Object.assign({}, res.data.data);
            console.log(temp);
            const modifiedRecord = {};
            this.idText = '账户ID';
            modifiedRecord.id = temp.sysUser.id;
            modifiedRecord.createUserName = temp.sysUser.createUserName;
            modifiedRecord.createTime = utils.formatTime(temp.sysUser.createTime);
            modifiedRecord.modifiedUserName = temp.sysUser.modifiedUserName;
            modifiedRecord.modifiedTime = utils.formatTime(temp.sysUser.modifiedTime);
            this.infos = modifiedRecord;

            // 回显信息
            this.headOfficeForm.authStoreIdList = res.data.data.authStoreIdList;
            // this.headOfficeForm.roleIdList = res.data.data.roleIdList;
            this.headOfficeForm.sysUser = res.data.data.sysUser;
            this.headOfficeForm.sysPositionList = res.data.data.sysPositionList;


            this.$set(this.headOfficeForm, 'roleList', this.headOfficeForm.sysPositionList[0].roleList.map(item => item.id));
            // this.headOfficeForm.roleList = ;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    confirmClear() {
      this.$refs.headOfficeForm.resetFields();
      this.headOfficeForm.authStoreIdList = [];
      if (this.$route.name !== 'headOfficeAccountAdd') {
        this.getInfos(this.$route.params.id);
      }
      this.showClear = false;
    },
    clear() {
      this.showClear = true;
    },
    isAllSelectStore(val) {
      if (val.includes(2)) {
        this.allSelectStore = true;
        val.splice(0, val.length);
        val.push(2);
      }
      if (val.length === 0) {
        this.allSelectStore = false;
      }
    },
  },
  created() {
    if (this.$route.name !== 'headOfficeAccountAdd') {
      Promise.all([
        this.getRoleInfos(),
        this.getStoreInfos(),
      ])
        .then(() => {
          this.getInfos(this.$route.params.id);
        });
    } else {
      this.getRoleInfos();
      this.getStoreInfos();
    }
  },
};
</script>
<style lang="less" scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
</style>
